import {
  PLAY_SOUND_BG,
  STOP_SOUND_BG,
  PLAY_SOUND_MAIN,
  PLAY_SOUND_MAIN_2,
  PAUSE_SOUND_MAIN,
  RESUME_SOUND_MAIN,
  USR_PAUSE_SOUND_MAIN,
  USR_RESUME_SOUND_MAIN,
  SEEK_SOUND_MAIN,
  STOP_SOUND_MAIN,
  END_SOUND_MAIN,
  STOP_SOUND_MAIN_2,
  PLAY_SOUND_OVERLAY,
  STOP_SOUND_OVERLAY,
  PLAY_SOUND_AMBIENT,
  STOP_SOUND_AMBIENT,
  VOLUME_UP_SOUND_AMBIENT,
  VOLUME_DOWN_SOUND_AMBIENT
} from './../actions/actions_audio'
import {
  VIEW_REMOVE,
} from './../actions/actions_router'


const initState = {
  sound_bg: null,
  sound_main: null,
  sound_main_2: null,
  sound_main_paused: false,
  sound_main_usr_paused: false,
  sound_main_seek: null,
  sound_main_ended_path: null,
  sound_overlay: null,
  sound_ambient: null,
  sound_ambient_vol_dwn: false,
}

export default (state = initState, action) => {
  switch (action.type) {
    case PLAY_SOUND_BG:
      return { ...state, sound_bg: action.payload }
    case STOP_SOUND_BG:
      return { ...state, sound_bg: null }
    case PLAY_SOUND_MAIN:
      const userPaused = state.sound_main && (state.sound_main.path == action.payload.path ? state.sound_main_usr_paused : false)
      return { ...state, sound_main: action.payload, sound_main_usr_paused: userPaused, sound_ambient_vol_dwn: !userPaused, sound_main_ended_path: action.payload.path != state.sound_main_ended_path ? null : state.sound_main_ended_path }
    case PLAY_SOUND_MAIN_2:
      return { ...state, sound_main_2: action.payload }
    case PAUSE_SOUND_MAIN:
      return { ...state, sound_main_paused: true, sound_ambient_vol_dwn: false }
    case RESUME_SOUND_MAIN:
      return { ...state, sound_main_paused: false, sound_ambient_vol_dwn: (!state.sound_main_usr_paused && !state.sound_main_ended_path) }
    case USR_PAUSE_SOUND_MAIN:
      return { ...state, sound_main_usr_paused: true, sound_ambient_vol_dwn: false, sound_main_ended_path: null }
    case USR_RESUME_SOUND_MAIN:
      return { ...state, sound_main_usr_paused: false, sound_ambient_vol_dwn: true, sound_main_ended_path: null }
    case SEEK_SOUND_MAIN:
      return { ...state, sound_main_seek: action.payload }
    case STOP_SOUND_MAIN:
      return { ...state, sound_main: null, sound_ambient_vol_dwn: false }
    case END_SOUND_MAIN:
      return { ...state, sound_ambient_vol_dwn: false, sound_main_usr_paused: false, sound_main_ended_path: action.payload }
    case STOP_SOUND_MAIN_2:
      return { ...state, sound_main_2: null }
    case PLAY_SOUND_OVERLAY:
      return { ...state, sound_overlay: action.payload }
    case STOP_SOUND_OVERLAY:
      return { ...state, sound_overlay: null }
    case PLAY_SOUND_AMBIENT:
      return { ...state, sound_ambient: action.payload }
    case STOP_SOUND_AMBIENT:
      return { ...state, sound_ambient: null }
    case VOLUME_UP_SOUND_AMBIENT:
      return { ...state, sound_ambient_vol_dwn: false }
    case VOLUME_DOWN_SOUND_AMBIENT:
      return { ...state, sound_ambient_vol_dwn: true }
    case VIEW_REMOVE:
      // remove pause on video view remove...
      return { ...state, sound_main_paused: false }
    default:
      return state
  }
}